export default {
  title_one: '🥳 {{offer}} toegepast',
  title_other: '🥳 {{count}} aanbiedingen toegepast',
};
